const RequiredField = () => {
  return <span style={{ color: "red" }}>*</span>;
};

export default RequiredField;
